import * as React from 'react';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import Benefit from './components/Benefit';
import Signpost from './components/Signpost';
import { FormattedNumber } from 'react-intl';
import * as Commonmark from 'react-commonmark';
import { IStore } from '../../../../redux/IStore';
import Loading from '../../../../components/Loading';
import FaInfoCircle from 'react-icons/fa/info-circle';
import FaCheck from 'react-icons/fa/check';
import { IAuthState } from '../../../../services/auth/models';
import SelectControl from '../../../../components/SelectControl';
import { II18nMessages } from '../../../../services/branding/models';
import FieldFormControl from '../../../../components/FieldFormControl';
import { recalculateScore } from '../../../../services/verisk/reducer';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { IQuoteState, IQuoteActions } from '../../../../services/quote/models';
import AlternativeDatePicker from '../../../../components/AlternativeDatePicker';
import { isEmpty, flow, map, startCase, size, forEach, difference, values, get } from 'lodash';
import { isRequired, isFutureDate, isValidDate, annualLimit } from '../../../../util/validators';
import { IBenefit, IChannel, IPolicyApplication, IProduct } from '../../../../data/api/models';
import { EventWithDataHandler, Field, formValueSelector, InjectedFormProps, reduxForm, submit } from 'redux-form';
import { Button, Form, Row, Col, Modal, FormGroup, ControlLabel, OverlayTrigger, Popover } from 'react-bootstrap';
import MaxTripDuration from '../TripDetails/components/MaxTripDuration/MaxTripDuration';
import NoCoverAvailable from './components/NoCoverAvailable';

// Auto-continue if it channel.key in the list

interface ISchemeChoiceFormProps extends InjectedFormProps {
  i18n: II18nMessages;
  quote: IQuoteState;
  application: IPolicyApplication;
  tripType: string;
  schemeId: string;
  startDate: string;
  password: string;
  passwordConfirmation: string;
  auth: IAuthState;
  endDate: string;
  pristine: boolean;
  submitting: boolean;
  region: string;
  destinations: string[];
  cruiseCover: boolean;
  maxTripDuration: string;
  dispatch: any;
  onBack: () => void;
  channel: IChannel;
  renderDefinition(name: string, icon?: string): any;
  recalculateScore(callback, screeningId, region, destinations);
  product: IProduct;
  actions: {
    submit(name: string);
    push: (route: string) => void;
    quote: IQuoteActions;
  };
}

interface ISchemeChoiceFormState {
  invalidFields: boolean;
  moreInfo: boolean;
  showUpSellModal: boolean;
  showSaveQuoteModal: boolean;
  isQuoteSaved: boolean;
  renderCoverChoicePage: boolean;
  columns: number;
  coverLevel: string;
  promptSingleQuote: boolean;
}

class SchemeChoiceForm extends React.Component<ISchemeChoiceFormProps, ISchemeChoiceFormState> {
  public state = {
    invalidFields: false,
    moreInfo: false,
    showUpSellModal: false,
    showSaveQuoteModal: false,
    isQuoteSaved: false,
    renderCoverChoicePage: true,
    columns: 0,
    coverLevel: '',
    promptSingleQuote: false,
  };

  public componentWillMount() {
    const { dispatch, schemeId, actions, change, quote, tripType, cruiseCover } = this.props;

    dispatch(change('steps', ['tripDetails', 'medicalDeclaration', 'schemeChoice']));
    dispatch(change('emailSend', false));

    if (schemeId) {
      dispatch(change('schemeId', ''));
      actions.quote.calculate(null, true);
    }

    forEach(quote.application.medicalDeclaration, (question: any) => {
      if (question.answer && question.prompt_single_quote && tripType === 'annual') {
        this.setState({
          promptSingleQuote: true,
        });
      }
    });
  }

  public componentWillReceiveProps(nextProps) {
    const { tripType, actions, quote } = this.props;

    // wrap func inside trip type so it doesn't break when retrieving a quote
    if (!tripType) {
      return;
    }

    let cols = 0;
    forEach(quote.quotes, (quotes) => {
      let benefitsKey = tripType;

      if (size(quotes) === 1) {
        benefitsKey = Object.keys(quotes)[0];
      }

      // check for errors/declines/referrals
      const hasError = benefitsKey && quotes[benefitsKey].errors.length > 0;
      const hasDeclines = quotes[benefitsKey].declines && quotes[benefitsKey].declines.length > 0;

      if (!hasError && !hasDeclines) {
        cols++;
      }
      const hasReferrals = quotes[benefitsKey].referrals && quotes[benefitsKey].referrals.length > 0;

      if (hasReferrals) {
        actions.quote.referralQuote(quote.application.id, quotes[benefitsKey].referrals);
      }

      if (hasReferrals) {
        this.setState({
          renderCoverChoicePage: false,
        });
      }
    });

    this.setState({
      renderCoverChoicePage: cols > 0,
      columns: cols,
    });
  }

  private handleSubmit = () => {
    const { change, dispatch, actions, region, maxTripDuration, product } = this.props;
    const annualTripDurations = Object.keys(get(product, 'metadata.annual_trip_durations', []));
    const checkMaxTrip = annualTripDurations.length > 1;

    // Don't close the modal if fields are invalid
    if (!region || (checkMaxTrip && !maxTripDuration)) {
      this.setState({
        invalidFields: true,
      });
      return;
    }

    dispatch(change('endDate', ''));
    dispatch(change('destinations', []));
    dispatch(change('tripType', 'annual'));

    setTimeout(() => {
      actions.quote.saveQuote(true);
      actions.submit('quote');
      this.setState({
        showUpSellModal: false,
      });
    }, 400);
  }

  private checkForUpSell = (checkSchemeId?: string) => {
    const { quote, schemeId: formSchemeId, actions, tripType, dispatch, change } = this.props;
    const schemeId = checkSchemeId ? checkSchemeId : formSchemeId;
    let shouldSubmit = false;

    forEach(quote.quotes, (quote) => {
      const annualQuote = quote && quote.annual && quote.annual;
      const singleQuote = quote && quote.single && quote.single;

      if (tripType === 'single' && schemeId === get(annualQuote, 'scheme.id')) {
        dispatch(change('region', annualQuote.information.region));
        this.setState({
          showUpSellModal: true,
          coverLevel: annualQuote.scheme.coverLevel,
        });
      }

      if (schemeId === singleQuote.scheme.id || tripType === 'annual') {
        shouldSubmit = true;
      }
    });

    if (shouldSubmit) {
      // I believe that this doesn't work initially because the form is pristine and this gets called
      // before this value is updated, so redux-form ignores the submit, so this allows time for
      // the form to finish validating and submit.
      setTimeout(() => {
        actions.submit('quote');
      }, 100);
    }
  }

  private closeUpSellModal = () => {
    const {change, dispatch } = this.props;
    dispatch(change('schemeId', ''));
    this.setState({
      showUpSellModal: false,
    });
  }

  private renderUpSellModal = () => {
    const { i18n, product, dispatch, change } = this.props;
    const { coverLevel } = this.state;

    const popoverClickRootClose = (
      <Popover id="popover-trigger-click-root-close" title="Regions">
        <Commonmark source={product.metadata.definitions.region_europe} />
        <Commonmark source={product.metadata.definitions.region_worldwide_excluding} />
        <Commonmark source={product.metadata.definitions.region_worldwide} />
      </Popover>
    );

    let regionsList = map(product.metadata.regions, (name, key) => ({
      label: name,
      value: key,
    }));
    const { region, cruiseCover, destinations } = this.props;
    const isUKOnly = region === 'uk' ||
      (destinations && destinations.length === 1 && destinations[0] === 'United Kingdom');
    if (['FST'].includes(product.productCode) && isUKOnly && !cruiseCover) {
      regionsList = regionsList.filter((region) => region.value === 'uk');
    }

    let maxTripDurationList = [];
    const maxTrips = get(product, 'metadata.max_trip_durations.' + coverLevel);
    if (maxTrips) {
      maxTripDurationList = map(maxTrips, (name, key) => ({
        label: name,
        value: key,
      }));
    } else {
      maxTripDurationList = map(product.metadata.annual_trip_durations, (name, key) => ({
        label: name,
        value: key,
      }));
    }

    const maxTripDefinition = get(product, 'metadata.definitions.max_trip_duration', {});
    const showMaxTripSelect = size(maxTripDurationList) > 1;

    if (!showMaxTripSelect) {
      dispatch(change('maxTripDuration', Object.keys(get(product, 'metadata.definitions.max_trip_duration', {}))[0]));
    }

    return (
      <Modal show={this.state.showUpSellModal} onHide={this.closeUpSellModal}>
        <Modal.Header closeButton={true}>
          <Modal.Title>Upgrading to Annual Multi-Trip</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="section-group">
            <div className="section">
              Please confirm the region that you require cover for.
              <p>
                If your selected region differs from the region of your original
                destination, this may affect the premium:
              </p>
              <Row className="margin-top">
                <FormGroup controlId="destination">
                  <Col componentClass={ControlLabel} sm={3}>
                    {i18n.quote.tripDetails.region}{' '}
                    <OverlayTrigger
                      trigger="click"
                      rootClose={true}
                      placement="right"
                      overlay={popoverClickRootClose}
                    >
                      <FaInfoCircle />
                    </OverlayTrigger>
                  </Col>
                  <Col sm={9} className="destinations-inputs">
                    <Field
                      name="region"
                      type="text"
                      component={SelectControl}
                      options={regionsList}
                      validate={[
                        isRequired,
                      ]}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <div className="margin-top">
                {showMaxTripSelect && (
                  <MaxTripDuration
                    isInvalid={this.state.invalidFields}
                    i18n={i18n}
                    options={maxTripDurationList}
                    definition={maxTripDefinition}
                    withPopover={true}
                  />
                )}
              </div>
            </div>
            <div className="section">
              <Row>
                <FormGroup controlId="start-date">
                  <Col componentClass={ControlLabel} xs={6}>
                    Start Date
                  </Col>
                  <Col sm={6}>
                    <div className="alternative-date-picker">
                      <div className="field">
                        <Field
                          name="startDate"
                          type="masked-date"
                          placeholder="dd/mm/yyyy"
                          component={FieldFormControl}
                        />
                      </div>
                      <div className="icon">
                        <Field
                          name="startDate"
                          maxDate={moment().add('90', 'days')}
                          component={AlternativeDatePicker}
                          validate={[ isRequired, isFutureDate, isValidDate, annualLimit ]}
                        />
                      </div>
                    </div>
                  </Col>
                </FormGroup>
              </Row>
              <div className="important margin-top">
                <strong>IMPORTANT</strong> - Cancellation cover begins on the date you choose
                to start your policy. If you already have a trip booked and you want to be covered
                immediately, you should select today’s date. You can choose to start your policy
                later (up to 31 days from today’s date) but there would not be any cancellation
                cover between now and the start date you choose.
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="primary"
            type="submit"
            onClick={this.handleSubmit}
          >
            Continue
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  private getBenefit = (benefits: IBenefit[], displayName, type?, subBenefitName?) => {
    let displayBenefit = '';
    let displayBenefitDescription = '';
    let subBenefit = [];
    let displaySubBenefit = '';

    benefits.forEach((benefit) => {
      if (benefit.displayName === displayName || benefit.name === displayName) {
        subBenefit = benefit.subBenefits;
        displayBenefit = benefit.text;
        displayBenefitDescription = benefit.description;
      }
      forEach(subBenefit, (item) => {
        if (item.name === subBenefitName) {
          displaySubBenefit = item.text;
        }
      });
    });

    switch (type) {
      case 'subBenefit':
        return displaySubBenefit;
      case 'description':
        return displayBenefitDescription;
      default:
        return displayBenefit;
    }
  }

  private unableToProvideQuoteMessage = () => {
    const { channel } = this.props;
    const isOnList = ['tpl-b2c'].includes(channel.key);
    if (isOnList) {
      return <span> Not available </span>;
    }

    return <span>Unable to quote online - please call {channel.phone}</span>;
  }

  private standardiseTheName = (name) => {
    if (name === 'backpacker') {
      name = 'Standard';
    }
    return startCase(name.replace('_', ' '));
  }

  private renderQuotes = () => {
    const { quote, product, tripType: tripTypeValue, schemeId, channel, maxTripDuration, cruiseCover } = this.props;
    if (!tripTypeValue) {
      return null;
    }

    const { moreInfo, columns } = this.state;
    const quotes = quote.quotes;
    let breakingPoint = channel.key === 'tpl-b2c' ? 9 : 12;
    const isFST = channel.key === 'fst-b2c';
    if (isFST) {
      breakingPoint = tripTypeValue === 'single' ? 4 : 5;
      if (cruiseCover) {
        breakingPoint = 9;
      }
    }
    const singleKey = 'single';
    const annualKey = 'annual';

    const filteredQuotes = Object.keys(quote.quotes).reduce((acc, key) => {
      if (isFST) {
        if (cruiseCover && ['standard', 'super', 'super_duper'].includes(key)) {
          return acc;
        }
        if (!cruiseCover && ['gold', 'platinum'].includes(key)) {
          return acc;
        }
      }

      acc[key] = quote.quotes[key];
      return acc;
    }, {});

    const orderedQuotes = product.metadata.scheme_order
      .map((order) => filteredQuotes[order])
      .filter(Boolean);

    // To avoid reading from undefined when navigating back to cover choice
    if (!orderedQuotes[0] || !orderedQuotes[1]) {
      return null;
    }

    const errors = [];

    orderedQuotes.forEach((tripTypes, level) => {
      // check for errors
      const hasError = tripTypes[tripTypeValue].errors.length > 0;
      const hasDeclines = tripTypes[tripTypeValue].declines.length > 0;
      const hasReferrals = tripTypes[tripTypeValue].referrals.length > 0;
      const unableToProvideQuote = hasError || hasDeclines || hasReferrals;
      if (unableToProvideQuote) {
        errors.push(level);
      }
    });

    if (errors.length === orderedQuotes.length) {
      return null;
    }

    return map(orderedQuotes, (tripTypes, level) => {
      const isSingleTrip = tripTypeValue === 'single';
      let displayAnnual = true;

      let benefitsKey = tripTypeValue;

      if (size(tripTypes) === 1) {
        benefitsKey = Object.keys(tripTypes)[0];
      }

      // define className if tripType = annual
      let containerClassName = tripTypes && tripTypes[benefitsKey].scheme.id === schemeId ?
        'quote-container active' : 'quote-container';
      if (isSingleTrip) {
        if ((tripTypes[singleKey] && tripTypes[annualKey] &&
          get(tripTypes[annualKey], 'gross', 0) < get(tripTypes[singleKey], 'gross', 0)) &&
          !['fst-b2c', 'tpl-b2c', '247-b2c', 'ven-b2c'].includes(channel.key)
        ) {
          displayAnnual = false;
        }

        containerClassName = (tripTypes && tripTypes[benefitsKey].scheme.id === schemeId) ||
          (tripTypes && annualKey && get(tripTypes, annualKey + '.scheme.id') === schemeId) ?
          'quote-container active' : 'quote-container';
      }

      const benefits = tripTypes && tripTypes[benefitsKey].benefits;
      const benefitsFlatten = this.flattenBenefits(benefits, channel, benefitsKey,
        tripTypes[benefitsKey].scheme.coverLevel);

      if (!tripTypes) {
        return null;
      }

      // check for errors
      const hasError = tripTypes[benefitsKey].errors.length > 0;
      const hasDeclines = tripTypes[benefitsKey].declines.length > 0;
      const hasReferrals = tripTypes[benefitsKey].referrals.length > 0;
      const unableToProvideQuote = hasError || hasDeclines || hasReferrals;

      if (unableToProvideQuote) {
        return <div/>;
      }

      // check for up sell errors
      const hasAnnualError = get(tripTypes, annualKey + '.errors', []).length > 0;
      const hasAnnualDeclines = get(tripTypes, annualKey + '.declines', []).length > 0;
      const hasAnnualReferrals = get(tripTypes, annualKey + '.referrals', []).length > 0;
      const unableToProvideAnnualQuote = hasAnnualError || hasAnnualDeclines || hasAnnualReferrals;
      // const coverLevel = tripTypes[benefitsKey].scheme.coverLevel;
      // const isSuper = coverLevel === 'super';
      // const isSuperDuper = coverLevel === 'super_duper';

      const renderValidation = !unableToProvideAnnualQuote;

      // Display the benefits container logic.
      const showBenefitsContainer = true;

      const selectQuoteBtnClass = ['select-quote-btn', channel.key === 'tpl-b2c' ? 'label--noTransform' : ''].join(' ');
      let bootstrapCols = {
        0: 9,
        1: 9,
        2: 4,
        3: 3,
        4: 2,
      };

      // This is a conditional set of columns, need a more consistent fix
      const maxTripIncludes = [60, 90, 120].includes(maxTripDuration);
      if (channel.key === 'mpt-b2c' && maxTripIncludes) {
        bootstrapCols = {
          0: 8,
          1: 8,
          2: 4,
          3: 3,
          4: 2,
        };
      }

      if (channel.key === 'fst-b2c') {
        bootstrapCols = {
          0: 9,
          1: 9,
          2: 6,
          3: 4,
          4: 2,
        };
      }
      const annual = 'annual';

      const columnCount = (channel.key === 'fst-b2c') ? (cruiseCover ? 2 : 3) : columns;
      const openPolicyWording = () => {
        window.open('https://example.com', '_blank', 'noopener,noreferrer');
      };
      return (
        <Col sm={bootstrapCols[columnCount]} key={level}>
          <div
            className={containerClassName}
          >
            <div className="quote-header">
              <p className="cover-level">
                {this.standardiseTheName(tripTypes[benefitsKey].scheme.coverLevel)}
              </p>
            </div>
            <div className="quote-body">

              {!unableToProvideQuote ? (
                <div>
                  {channel.key === 'fst-b2c' ? (
                    <span className="scheme-type-box">
                      {benefitsKey === 'single' ? 'Single Cover' : 'Annual Multi-Trip Cover'}
                    </span>
                  ) : (
                    <span className="scheme-type">
                      {benefitsKey}
                    </span>
                  )}
                  <h1 style={{marginTop: '20px'}}>
                    <FormattedNumber
                      value={tripTypes ? get(tripTypes, benefitsKey + '.gross', 0) : 0}
                      style="currency"
                      currency={tripTypes[benefitsKey].currency}
                    />
                  </h1>
                  <Field
                    name="schemeId"
                    type="radio"
                    value={tripTypes[benefitsKey].scheme.id}
                    className="select-quote"
                    component={FieldFormControl}
                    validate={[isRequired]}
                    onChange={this.handleSchemeIdChange}
                  >
                    <div className={selectQuoteBtnClass}>
                      {tripTypes[benefitsKey].scheme.id === schemeId ? 'Selected' : 'Select'}
                    </div>
                  </Field>

                </div>
              ) : this.unableToProvideQuoteMessage()}

              {isSingleTrip && tripTypes[annualKey] && (
                <div>
                  {renderValidation && get(tripTypes, benefitsKey + '.gross', 0) !== 0 && displayAnnual ? (
                    <div className="annual-quotes">
                      {channel.key === 'fst-b2c' ? (
                        <span className="scheme-type-box">
                          Annual Multi-Trip Cover
                        </span>
                      ) : (
                        <span className="scheme-type">
                          {annualKey}
                        </span>
                      )}

                      {channel.key === 'fst-b2c' ? (
                          <h1 style={{marginTop: '20px'}}>
                            <FormattedNumber
                              value={tripTypes ? get(tripTypes[annualKey], 'gross', 0) : 0}
                              style="currency"
                              currency={tripTypes[annualKey].currency}
                            />
                          </h1>
                        ) : (
                        <h1>
                          <FormattedNumber
                            value={tripTypes ? get(tripTypes[annualKey], 'gross', 0) : 0}
                            style="currency"
                            currency={tripTypes[annualKey].currency}
                          />
                        </h1>
                      )}
                      <Field
                        name="schemeId"
                        type="radio"
                        value={tripTypes[annualKey].scheme.id}
                        className="select-quote"
                        component={FieldFormControl}
                        validate={[isRequired]}
                        onChange={this.handleSchemeIdChange}
                      >
                        <div className={selectQuoteBtnClass}>
                          {tripTypes[annualKey].scheme.id === schemeId ? 'Selected' : 'Select'}
                        </div>
                      </Field>
                    </div>
                  ) : (
                    <div className="annual-quotes unable-quote-container">
                      {this.unableToProvideQuoteMessage()}
                    </div>
                  )}
                </div>
              )}
              {!unableToProvideQuote && quote.signpost ?
                <Row>
                  <Signpost signpost={quote.signpost} channel={channel} />
                </Row>
                :
                <div />
              }
              {showBenefitsContainer ? (
                <Row className="benefit-section">
                  {channel.key !== 'lsb-b2c' && (
                    <div>
                      <Benefit
                        title={'Standard Excess'}
                        description={null}
                        value={get(tripTypes[benefitsKey], 'information.standardExcess')}
                        channel={channel}
                      />
                    </div>
                  )}
                  {benefitsFlatten && benefitsFlatten.map((benefit, key) => {
                    if (key === breakingPoint) {
                      return (
                        <div key={key} id="view-document-section">
                          <Benefit
                            title={benefit.name}
                            description={this.getBenefit(benefitsFlatten, benefit.name, 'description')}
                            value={this.getBenefit(benefitsFlatten, benefit.name)}
                            channel={channel}
                          />

                          <div className="view-document-container">
                            <div className="view-title">
                              Insurance Product Information Document
                            </div>
                            <Button className="view-btn" block={true}
                                    onClick={this.downloadDocument(tripTypes[benefitsKey].scheme.documents, 'ipid')}>
                              VIEW {channel.key === 'fst-b2c' ? 'IPID' : ''}
                            </Button>
                          </div>

                          {channel.key === 'fst-b2c' ? (
                            <div className="more-info-btn-container">
                              <Button
                                className="more-info-btn" block={true}
                                onClick={
                                this.downloadDocument(tripTypes[benefitsKey].scheme.documents, 'policy_wording')}>
                                View Policy Wording
                              </Button>
                            </div>
                          ) : (
                            <div className="more-info-btn-container">
                              <Button className="more-info-btn" block={true} onClick={this.toggleMoreInfo}>
                              {moreInfo ? 'less info' : 'more info'}
                              </Button>
                            </div>
                          )}
                        </div>
                      );
                    }

                    if (key > breakingPoint) {
                      if (moreInfo) {
                        return (
                          <div>
                            <Benefit
                              key={key}
                              title={benefit.name}
                              description={this.getBenefit(benefitsFlatten, benefit.name, 'description')}
                              value={this.getBenefit(benefitsFlatten, benefit.name)}
                              channel={channel}
                            />
                          </div>
                        );
                      }
                      return null;
                    }

                    return (
                      <Benefit
                        key={key}
                        title={benefit.name}
                        description={this.getBenefit(benefitsFlatten, benefit.name, 'description')}
                        value={this.getBenefit(benefitsFlatten, benefit.name)}
                        channel={channel}
                      />
                    );
                  })}
                </Row>) : null}
            </div>
          </div>
        </Col>
      );
    });
  }

  private toggleMoreInfo = () => {
    this.setState((prevState) => ({
      moreInfo: !prevState.moreInfo,
    }));
  }

  private downloadDocument = (benefitsKey, key) => () => {
    let file = '';
    // tslint:disable-next-line:prefer-conditional-expression
    if (key === 'ipid') {
      file = 'Insurance Product Information Document';
    } else {
      file = 'Policy Wording';
    }

    const toDownload = benefitsKey[file];
    if (window) {
      window.open(toDownload, '_blank');
    }
  }

  /**
   * Return an array of Objects with subBenefits in the same level of
   * benefits with helper keys to identity if it is a subBenefit or a benefit.
   *  @return: array: [{ name: 'Winter', hasSubBenefits: true }, { name: 'Ski Pack', subkeyOf: 'Winter' }]
   * @param benefits
   * @param channel
   * @param benefitsKey
   * @param coverLevel
   */
  private flattenBenefits = (benefits, channel = null, benefitsKey = null, coverLevel = null) => {
    const { cruiseCover } = this.props;
    const benefitsFlatten = [];
    if (channel && channel.key === 'fst-b2c') {
      if (benefitsKey && benefitsKey === 'annual') {
        let days = '32 days';
        if (coverLevel === 'super_duper' || coverLevel === 'platinum') {
          days = '45 days';
        }
        benefitsFlatten.push({
          name: 'Max Trip Duration',
          text: days,
          hasSubBenefits: false,
        });
        if (cruiseCover) {
          benefitsFlatten.push({
            name: 'Cruise Specific Cover',
            text: <FaCheck />,
            hasSubBenefits: false,
          });
        }
      }
      let allowedBenefits = [
        'Gadget Cover',
        'Cancellation',
        'Emergency Medical and Other Expenses',
        'Personal Possessions',
        'Missed Departure',
      ];

      if (cruiseCover) {
        allowedBenefits = [
          'Emergency Medical and Other Expenses',
          'Cancellation',
          'Personal Possessions',
          'Gadget Cover',
          'Cruise Benefits',
        ];
      }
      benefits.forEach((benefit) => {
        if (allowedBenefits.includes(benefit.name) && benefit.display !== false) {
          if (benefit.name === 'Cruise Benefits') {
            const allowedSubBenefits = [
              'Ship to shore repatriation',
              'On board medical fees',
              'Missed Embarkation',
              'Formal Cruise Attire',
            ];
            benefit.subBenefits.forEach((subBenefit) => {
              if (allowedSubBenefits.includes(subBenefit.name) && subBenefit.display !== false) {
                benefitsFlatten.push({
                  name: subBenefit.name,
                  text: subBenefit.text,
                  hasSubBenefits: false,
                });
              }
            });
          } else {
            benefitsFlatten.push({
              name:
                benefit.name === 'Emergency Medical and Other Expenses'
                  ? 'Medical Expenses'
                  : benefit.name,
              text: benefit.text,
              hasSubBenefits: benefit.subBenefits && benefit.subBenefits.length > 0,
            });
          }
        }
      });

      if (!cruiseCover) {
        benefitsFlatten.sort((a, b) => allowedBenefits.indexOf(a.name) - allowedBenefits.indexOf(b.name));
      } else {
        const allowedCruiseBenefits = [
          'Emergency Medical and Other Expenses',
          'Cancellation',
          'Personal Possessions',
          'Gadget Cover',
          'Cruise Benefits',
          'Ship to shore repatriation',
          'On board medical fees',
          'Missed Embarkation',
          'Formal Cruise Attire',
        ];
        benefitsFlatten.sort((a, b) => allowedCruiseBenefits.indexOf(a.name) - allowedCruiseBenefits.indexOf(b.name));
      }
    } else {
      benefits.map((benefit) => {
        if (benefit.display !== false) {
          benefitsFlatten.push({
            name: benefit.name,
            text: benefit.text,
            hasSubBenefits: benefit.subBenefits && benefit.subBenefits.length > 0,
          });
        }
        if (!isEmpty(benefit.subBenefits)) {
          benefit.subBenefits.map((key) => {
            if (key.display !== false) {
              benefitsFlatten.push(
                {
                  name: key.name,
                  text: key.text,
                  subkeyOf: benefit.name,
                },
              );
            }
          });
        }
      });
    }
    return benefitsFlatten;
  }

  private renderLeftSideHelper = () => {
    const { quote, tripType, renderDefinition, channel, product } = this.props;
    const { moreInfo } = this.state;
    const quotes = quote.quotes;

    if (channel.key === 'fst-b2c') {
      return;
    }
    // Get the first ObjectKey e.g.(super/essential) to use as a reference to list the benefits labels
    const keyReference = Object.keys(quotes)[1];
    const keyReference2 = Object.keys(quotes)[0];

    let benefits = quote.quotes[keyReference][tripType].benefits;

    // Fall Back Temp Fix
    if (benefits && benefits.length === 0) {
      benefits = quote.quotes[keyReference2][tripType].benefits;
    }

    const benefitsFlatten = this.flattenBenefits(benefits);

    let tripTypeDefinition = 'trip_type_single';
    if (tripType === 'annual') {
      tripTypeDefinition = 'trip_type_annual';
    }
    const tripTypeArrow = ['trip-type-arrow', tripType === 'annual' ? 'trip-type-arrow--annual' : ''];

    if (channel.key === 'tpl-b2c' && tripType !== 'annual') {
      tripTypeArrow.push('trip-type-arrow--tpl');
    }

    if (['247-b2c', 'ven-b2c'].includes(channel.key) && tripType !== 'annual') {
      tripTypeArrow.push('trip-type-arrow--247');
    }

    const tripTypeArrowClass = tripTypeArrow.join(' ');

    const hasExtraColumn = values(quotes).length >= 3; // hasExtraColumn ? 3 : 4}
    const renderAnnualTitle = channel.key === 'tpl-b2c' ? 'Annual Multi-Trip' : 'Annual Multi-Trip Cover';
    const renderSingleTile = channel.key === 'tpl-b2c' ? 'Single' : 'Single Cover';
    // const isSpace = ['tpl-b2c', 'mpt-b2c'].includes(channel.key);
    // const space = [isSpace ? '' : 'more-info-space'].join(' ');
    const breakingPoint = channel.key === 'tpl-b2c' ? 9 : 12;
    let divCheck = 0;

    if (document.getElementById('signpost-quote-div')) {
      divCheck = document.getElementById('signpost-quote-div').offsetHeight + 20;
    }

    return (
      <Col xs={hasExtraColumn ? 3 : 4}>
        <div className="quote-helper">
          <div className="trip-type-container">
            <div className={tripTypeArrowClass + '--single'}>
              {renderDefinition(tripTypeDefinition, 'FaInfo')}
              {tripType === 'single' ? renderSingleTile : renderAnnualTitle}
            </div>
          </div>
          {tripType === 'single' && product.metadata.trip_type.annual && (
            <div className="trip-type-container">
              <div className={tripTypeArrowClass}>
                {renderDefinition('trip_type_annual', 'FaInfo')}
                {renderAnnualTitle}
              </div>
            </div>
          )}
          {!!quote.signpost  && (<div className={'signpost-quote-container'} style={{ height: divCheck }} />)}
          {channel.key !== 'lsb-b2c' && (
            <div className="benefit-container">
              <p className="benefit-title--strong" >
                Standard Excess
              </p>
            </div>
          )}
          {benefitsFlatten.map((benefit, key) => {
            const classname = [
              'benefit-title',
              'benefit-title--strong',
              benefit.subkeyOf && 'benefit-title--subkey',
            ].join(' ');

            const isWinterSports = benefit.name === 'Winter Sports';
            let winterSportsText = '';

            if (isWinterSports) {
              winterSportsText = '*';
            }

            if (isWinterSports && ['247-b2c', 'ven-b2c'].includes(channel.key)) {
              winterSportsText = '(optional)';
            }

            if (key === breakingPoint) {
              return (
                <div key={key} >
                  <div className="benefit-container">
                    <p className={classname} >
                      {benefit.name}
                    </p>
                  </div>
                  <div className="benefit-container">
                    <p className={`benefit-title-top ${classname}`}>
                      Insurance Product Information Document
                    </p>
                  </div>
                  {/*<div className={space} />*/}
                </div>
              );
            }

            if (key > breakingPoint) {
              if (moreInfo) {
                return (
                  <div key={key} className="benefit-container">
                    <p className={classname} >
                      {benefit.name} {winterSportsText}
                    </p>
                  </div>
                );
              }
              return null;
            }
            return (
              <div key={key} className="benefit-container">
                <p className={classname} >
                  {benefit.name}
                </p>
              </div>
            );
          })}
        </div>
      </Col>
    );
  }

  private handleSchemeIdChange: EventWithDataHandler<Event> = (event, newValue) => {
    const { dispatch, change } = this.props;

    // Because check for upsell causes a submit, this ensures that the value is in the redux form store
    // before it is submitted. Otherwise it will be updated after this function call finishes.
    event.preventDefault();
    dispatch(change('schemeId', newValue));

    this.checkForUpSell(newValue);
  }

  public renderLoader() {
    return (
      <div className="schemes-loader text-center">
        <Loading />
        <p>
          Please wait whilst we generate your premiums...
        </p>
      </div>
    );
  }

  public render() {
    const {
      handleSubmit,
      quote,
      channel,
      product,
      tripType: tripTypeValue,
      onBack } = this.props;
    const { renderCoverChoicePage, moreInfo, promptSingleQuote } = this.state;
    const quotes = quote.quotes;
    const noAvailableQuotes = isEmpty(quotes);
    const callMessage = {
      free: 'Simply call our UK-based specialist customer service team FREE on',
      cost: 'Simply call our UK-based specialist customer service team on',
    };
    const productCallMessage = {
      FST: callMessage.free,
      TPL: callMessage.cost,
      MPT: callMessage.cost,
    };
    const renderCallMessage = productCallMessage[product.productCode];
    const hasFinishedCalculation = values(quotes).length >= 2;
    const phoneNumber = channel.referralNumber ? channel.referralNumber : channel.phone;
    const quoteReference = quote.application.quoteReference && quote.application.quoteReference;

    if (quote.isCalculating) {
      return this.renderLoader();
    }

    const displayMoreInfo = tripTypeValue === 'single' && channel.key === 'mpt-b2c';
    const coverChoices = this.renderQuotes();

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        {!noAvailableQuotes ? (
          <div className="scheme-choice-section">
            <div className="section-title" style={{ textAlign: 'center' }}>
              <h1>COVER CHOICE</h1>
              <p style={{ textAlign: 'left' }}>You can access your quote at any
time within the next 31 days, but prices can only be guaranteed
at the time of the quote</p>
            </div>

            <div className="available-quotes">
              {renderCoverChoicePage && coverChoices ? (
                <div>
                  <Row>
                    {hasFinishedCalculation && this.renderLeftSideHelper()}
                    {hasFinishedCalculation && coverChoices}
                    {moreInfo && displayMoreInfo && (
                      <Col sm={12}>
                        <p>
                          *Winter Sports cover is only in force if shown on your Policy
                          Schedule and the appropriate additional premium is paid.
                        </p>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    {channel.key === 'lsb-b2c' && (
                      <Col sm={12}>
                        <p>
                          This travel insurance is typically suitable for those people who wish to insure themselves
                          when travelling for the benefits as shown in the policy wording. You may already possess
                          alternative insurance for some or all of the features and benefits provided by this product.
                          It is your responsibility to investigate this. We cannot provide you with any recommendations
                          or advice about whether this product fulfils your specific insurance requirements.
                        </p>
                      </Col>
                    )}
                  </Row>
                </div>
              ) : (
                <div className="unable-box">
                  <NoCoverAvailable
                    promptSingleQuote={promptSingleQuote}
                    channel={channel}
                    quoteReference={quote.application.quoteReference}
                    callMessage={renderCallMessage}
                    signpost={quote.signpost}
                  />
                </div>
              )}
            </div>

            {renderCoverChoicePage && coverChoices && (
              <div className="btn-bar">
                <Button type="button" className="btn-back" onClick={onBack}>
                  Back
                </Button>
              </div>
            )}

            {this.renderUpSellModal()}
          </div>
        ) : (
          <div className="steps-container unable-box">
            <p>Sorry, we are not able to complete your quotation online as we need a few more details.<br/><br/>
              Simply call our UK-based specialist customer service team on {phoneNumber} quoting {quoteReference}{' '}
              who will discuss your requirements with you.<br/><br/>
              We are open {channel.openingHours}, closed Bank Holidays.
            </p>
          </div>
        )}
      </Form>
    );
  }
}

let selector;
let previousValues;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onChange: (
      values: IPolicyApplication,
      dispatch,
      props: ISchemeChoiceFormProps,
    ) => {
      if (! previousValues) {
        previousValues = values;
        return;
      }

      let recalculateScore = false;

      if (difference(values.destinations, previousValues.destinations).length > 0) {
        recalculateScore = true;
      }

      if (values.region !== previousValues.region) {
        recalculateScore = true;
      }

      if (recalculateScore) {
        props.actions.quote.recalculateScreening();
      }

      previousValues = values;
    },
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const quote = state.quote;
      const tripType = selector(state, 'tripType');
      const maxTripDuration = selector(state, 'maxTripDuration');
      const schemeId = selector(state, 'schemeId');
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const travellers = selector(state, 'travellers');
      const region = selector(state, 'region');
      const destinations = selector(state, 'destinations');
      const password = selector(state, 'password');
      const passwordConfirmation =  selector(state, 'passwordConfirmation');
      const steps =  selector(state, 'steps');
      const cruiseCover =  selector(state, 'going_on_cruise');

      return {
        quote,
        tripType,
        schemeId,
        startDate,
        endDate,
        travellers,
        region,
        destinations,
        password,
        passwordConfirmation,
        maxTripDuration,
        steps,
        cruiseCover,
        auth: state.auth,
        channel: state.branding.channel,
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        submit: bindActionCreators(submit, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
        push: bindActionCreators(push, dispatch),
        recalculateScore: bindActionCreators(recalculateScore, dispatch),
      },
    }),
  ),
])(SchemeChoiceForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoice/index.tsx